export const keyupEnter = () => {
  return new Promise((resolve) => {
    document.onkeydown = (e) => {
      console.log(e);
      let body = document.getElementsByTagName('body')[0];
      //   return e.key === 'Enter' && e.target === body;
      console.log(e.key === 'Enter' && e.target === body);
      resolve(e.key === 'Enter' && e.target === body);
    };
  });
};
